import { render, staticRenderFns } from "./Identity.vue?vue&type=template&id=bc39fd2a&scoped=true"
import script from "./Identity.vue?vue&type=script&lang=js"
export * from "./Identity.vue?vue&type=script&lang=js"
import style0 from "./Identity.vue?vue&type=style&index=0&id=bc39fd2a&prod&lang=css"
import style1 from "./Identity.vue?vue&type=style&index=1&id=bc39fd2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc39fd2a",
  null
  
)

export default component.exports